module.exports = __webpack_public_path__ + "img/Angiogenesis-CECA_10X_CC.95c701c1.png";